import {
  ROUTE_PATH,
  ROUTE_PATHS_WITH_CATEGORIES,
  ROUTE_PATHS_WITHOUT_CATEGORIES
} from 'modules/routes/constants/index.cjs'
import isAppRouteUtil from 'modules/routes/utils/is-app'

/**
 * Checks whether the current pathname has categories
 * @param  {string}  pathname
 * @returns {boolean}
 */
function hasCategoriesRouteUtil (pathname) {
  if (pathname === ROUTE_PATH.HOME) {
    return false
  }

  return !isAppRouteUtil(pathname) && !!(
    !ROUTE_PATHS_WITHOUT_CATEGORIES.some(path => !pathname.indexOf(path)) ||
    ROUTE_PATHS_WITH_CATEGORIES.some(path => pathname.includes(path))
  )
}

export default hasCategoriesRouteUtil
